var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import * as dayjs from 'dayjs';
import translations from './translations';
import css from './style.pcss';
import GewitterImage from "./images/gewitter.svg";
import GlatteisImage from "./images/glatteisregen.svg";
import SchneefallImage from "./images/schneefall.svg";
import SturzflutImage from "./images/sturzflut.svg";
import WindImage from "./images/wind.svg";
var RTLWiederwarnungen = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLWiederwarnungen, _LitElement);
  function RTLWiederwarnungen() {
    var _this;
    _classCallCheck(this, RTLWiederwarnungen);
    _this = _callSuper(this, RTLWiederwarnungen);
    _this.language = 'lu';
    _this.nocheck = false;
    _this.v = dayjs().format('DDMMYYYYHHmm');
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
    }
    return _this;
  }
  _createClass(RTLWiederwarnungen, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLWiederwarnungen.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      this._apiUrl = `https://static.rtl.lu/meteo/warnings/latest_polygons.json?v=${this.v}`;
      console.log("URL", this._apiUrl);
      fetch(this._apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
      });
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "render",
    value: function render() {
      if (this.data == undefined) return html(_t || (_t = _`Loading...`));
      if (this.data.length == 0 && this.nocheck === false) return html(_t2 || (_t2 = _``));
      var link = '/meteo/wiederwarnungen';
      if (this.language == 'fr') link = '/services/alerte-meteo';
      if (this.language == 'en') link = '/info/weather';

      //console.log(this.nolegend);

      return html(_t3 || (_t3 = _`
            <style>${0}</style>
            <section class="l-section l-section--maxwidth flavor-section--services flavor-section--info flavor-section--meteo">
                ${0}
            </section>
        `), css, !this.nolegend ? html(_t4 || (_t4 = _`
                    <div class="l-section__title">
                        <span class="l-section__title-text">${0}</span>
                    </div>
                    <img src="https://www.rtl.lu/meteo/warnings/data/luxwarn_1600.png?v=${0}" width="100%" />
                    <div class="wiederwarnungen__legend">
                        <ul class="wiederwarnungen-legend">
                            <li class="wiederwarnungen-legend__item">
                                <img src="${0}" width="40">
                                <span>${0}<span>
                            </li>
                            <li class="wiederwarnungen-legend__item">
                                <img src="${0}" width="40">
                                <span>${0}<span>
                            </li>
                            <li class="wiederwarnungen-legend__item">
                                <img src="${0}" width="40">
                                <span>${0}<span>
                            </li>
                            <li class="wiederwarnungen-legend__item">
                                <img src="${0}" width="40">
                                <span>${0}<span>
                            </li>
                            <li class="wiederwarnungen-legend__item">
                                <img src="${0}" width="40">
                                <span>${0}<span>
                            </li>
                        </ul>

                        <ul class="wiederwarnungen-legend wiederwarnungen-legend--rows">
                            <li class="wiederwarnungen-legend__item"><span class="wiederwarnungen-legend__dot wiederwarnungen-legend__dot--orange"></span>${0}</li>
                            <li class="wiederwarnungen-legend__item"><span class="wiederwarnungen-legend__dot wiederwarnungen-legend__dot--red"></span>${0}</li>
                            <li class="wiederwarnungen-legend__item"><span class="wiederwarnungen-legend__dot wiederwarnungen-legend__dot--violet"></span>${0}</li>
                        </ul>
                    </div>
                    <div class="wiederwarnungen__source">Source: <a href="https://kachelmannwetter.com/lu" target="_blank">https://kachelmannwetter.com/lu</a></div>
                `), this._getTranslation('title'), this.v, GewitterImage, this._getTranslation('thunderstorm'), GlatteisImage, this._getTranslation('freezing_rain'), SchneefallImage, this._getTranslation('snowfall'), WindImage, this._getTranslation('high_winds'), SturzflutImage, this._getTranslation('flash_floods'), this._getTranslation('orange'), this._getTranslation('red'), this._getTranslation('violet')) : html(_t5 || (_t5 = _`
                    <div class="l-section__title">
                        <a href="${0}" class="l-section__title-action"><span class="l-section__title-text">${0}</span></a>
                    </div>
                    <a href="${0}"><img src="https://www.rtl.lu/meteo/warnings/data/luxwarn_640.png?v=${0}" width="100%" /></a>
                    <div class="wiederwarnungen__source">Source: <a href="https://kachelmannwetter.com/lu" target="_blank">https://kachelmannwetter.com/lu</a></div>
                `), link, this._getTranslation('title'), link, this.v));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        nocheck: {
          type: Boolean
        },
        nolegend: {
          type: Boolean
        },
        language: {
          type: String
        }
      };
    }
  }]);
  return RTLWiederwarnungen;
}(LitElement);
export { RTLWiederwarnungen as default };
window.customElements.define('rtl-wiederwarnungen', RTLWiederwarnungen);